import WidgetDownloadSpeed from "./widget-download-speed";

export default WidgetDownloadSpeed;